import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@frontend/styles/globals.css';

import { App } from './App';
import { watchSystemTheme } from './store/preferences';

// Follow the OS theme for users who have not chosen one. The initial value was already
// applied by the pre-paint script in index.html; this only keeps it in sync afterwards.
watchSystemTheme();

const container = document.getElementById('root');
if (container === null) {
  throw new Error('#root is missing from index.html — the app cannot mount.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
